"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UncheckedAll;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function UncheckedAll(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "unchecked-all"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M67.72,92.5H16.93A9.44,9.44,0,0,1,7.5,83.07V32.28a9.44,9.44,0,0,1,9.43-9.43H67.72a9.44,9.44,0,0,1,9.43,9.43V83.07A9.44,9.44,0,0,1,67.72,92.5ZM16.93,27.85a4.44,4.44,0,0,0-4.43,4.43V83.07a4.44,4.44,0,0,0,4.43,4.43H67.72a4.44,4.44,0,0,0,4.43-4.43V32.28a4.44,4.44,0,0,0-4.43-4.43ZM92.5,67.72V16.93A9.44,9.44,0,0,0,83.07,7.5H32.28a9.44,9.44,0,0,0-9.43,9.43,2.5,2.5,0,0,0,5,0,4.44,4.44,0,0,1,4.43-4.43H83.07a4.44,4.44,0,0,1,4.43,4.43V67.72a4.44,4.44,0,0,1-4.43,4.43,2.5,2.5,0,0,0,0,5A9.44,9.44,0,0,0,92.5,67.72Z"
  }))));
}